import { useEffect, useState } from "react";

import useSessionStore from "../stateManagement/sessionState/sessionStore";

const useScrollDirection = () => {
  const scrollDirection = useSessionStore((store) => store.scrollDirection);
  const setScrollUp = useSessionStore((store) => store.setScrollUp);
  const setScrollDown = useSessionStore((store) => store.setScrollDown);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener("scroll", updatePosition);
  }, []);

  useEffect(() => {
    if (scrollPosition < lastScrollPosition) {
      setScrollUp();
    }
    if (scrollPosition > lastScrollPosition) {
      setScrollDown();
    }
    setLastScrollPosition(scrollPosition);
  }, [scrollPosition, lastScrollPosition, setScrollUp, setScrollDown]);

  return { scrollDirection, scrollPosition: lastScrollPosition };
};

export default useScrollDirection;
